export default __webpack_public_path__ + "static/media/mochi-logo.15d84fe6.png";